export enum MENTION_STATUS {
  PENDING_VIEWING = 'pending_viewing',
  PENDING_RESOLUTION = 'pending_resolution',
  CLOSED = 'closed'
}

export interface IUpdateMentionDto {
  wasSeen?: boolean;
  wasResolved?: boolean;
}

export interface IBulkUpdateMentionsDto {
  wasSeen: boolean;
  wasResolved: boolean;
  mentionIds: number[];
}

export const MENTION_TYPES = {
  ORDER: 'order',
  LOGISTIC_SERVICE: 'logisticService',
  STOCK_ORDER: 'stockOrder'
} as const;

export type TMentionTypes = typeof MENTION_TYPES[keyof typeof MENTION_TYPES];

export interface IMentioner {
  id: number;
  name: string;
}

export interface IComment {
  sourceId: number;
  sourceUuid?: string;
  comment: string;
  imageUrl?: string;
  commentTypeName?: string;
}

export interface IGroupedMentionWithMentioner {
  id: number;
  wasSeen: boolean;
  wasResolved: boolean;
  createdAt: string;
  mentioner: IMentioner;
  comment: IComment;
  commentTypeName?: string;
}

export enum MENTION_DASHBOARD_CHANNEL {
  OPERATIONS = 'operations',
  CUSTOMER_CHAT = 'customerChat',
}

export type TMentionDashboardChannel = MENTION_DASHBOARD_CHANNEL;

export interface IGroupedMention {
  sourceId: number;
  sourceUuid?: string;
  type: TMentionTypes;
  mentions: IGroupedMentionWithMentioner[];
}

export interface IGroupedMentionsResponse {
  pendingViewingMentions: IGroupedMention[];
  pendingResolutionMentions: IGroupedMention[];
  resolvedMentions: IGroupedMention[];
}
